import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Button from "@mui/material/Button";
import { Box, CircularProgress } from "__barrel_optimize__?names=Box,CircularProgress!=!@mui/material";
import { appStyled } from "../utilityFunctions";
const StyledButton = appStyled(Button)((param)=>{
    let { theme, $color, $width, $backgroundColor, $backgroundColorOnHover, $borderColor, $allowTextWrap, disabled, fontSize } = param;
    return {
        borderRadius: "12px",
        fontWeight: 600,
        fontSize: fontSize ? fontSize : "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        ...$color && {
            color: $color
        },
        whiteSpace: $allowTextWrap && $width ? "normal" : "nowrap",
        textOverflow: $allowTextWrap && $width ? "clip" : "ellipsis",
        overflow: "hidden",
        padding: "10px 24px",
        boxShadow: "none",
        ...$allowTextWrap ? {
            minHeight: "48px",
            boxSizing: "border-box",
            maxWidth: "100%",
            minWidth: $width ? 0 : "fit-content",
            lineHeight: 1.2,
            textAlign: "center",
            overflowWrap: "anywhere",
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                flexShrink: 0
            }
        } : {
            height: "48px",
            minWidth: "fit-content"
        },
        ...$width && {
            width: $width
        },
        ...$backgroundColor && {
            background: $backgroundColor
        },
        ...$borderColor && {
            border: "1px solid ".concat(disabled ? "rgba(0, 0, 0, 0.26)" : $borderColor)
        },
        ...$backgroundColorOnHover ? {
            "&:hover": {
                background: $backgroundColorOnHover
            }
        } : {
            "&:hover": {
                background: $backgroundColor
            }
        },
        [theme.breakpoints.down("sm")]: {
            padding: "8px 16px",
            fontSize: "16px"
        }
    };
});
const ReusableButton = (props)=>{
    var _props_loadingText;
    return /*#__PURE__*/ _jsx(Box, {
        pt: props.paddingTop,
        pr: props.paddingRight,
        pl: props.paddingLeft,
        pb: props.paddingButtom,
        sx: {
            ...props.width && {
                width: props.width
            }
        },
        children: /*#__PURE__*/ _jsx(StyledButton, {
            id: props.id,
            form: props.form,
            disabled: props.disabled || props.loading,
            type: props.type,
            // disableRipple
            $color: props.color,
            $width: props.width,
            $backgroundColor: props.backgroundColor,
            $backgroundColorOnHover: props.backgroundColorOnHover,
            $borderColor: props.borderColor,
            $allowTextWrap: props.allowTextWrap,
            fontSize: props.fontSize,
            onClick: props.onClick,
            startIcon: props.loading ? /*#__PURE__*/ _jsx(CircularProgress, {
                color: "inherit",
                size: 20
            }) : props.startIcon,
            endIcon: props.loading ? undefined : props.endIcon,
            children: props.loading ? (_props_loadingText = props.loadingText) !== null && _props_loadingText !== void 0 ? _props_loadingText : props.name : props.name
        })
    });
};
export default ReusableButton;
